export default __webpack_public_path__ + "static/media/Dolphins.66750198.jpg";